// const BASE_URL = "https://api.pawansut.com";
const BASE_URL = "http://localhost:3000";

export default BASE_URL;